<template>
  <div>
    <!-- <main role="main"> -->
    <div class="page-content">
      <div class="container py-md-5 py-4">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <h2 class="page-title mb-md-0 mb-3">All Grooms</h2>
          </div>
          <div class="col-md-8 form-style d-flex justify-content-end disInline">
            <div class="col-md-4 form-group mb-0 me-3">
              <label>Marital Status</label>
              <div class="marginBTM">
                <select
                  class="form-select form-control"
                  v-model="status_id"
                  v-on:change="selectStatus()"
                >
                  <option value="">Select Marital Status</option>
                  <option
                    v-for="(data, index) in marital_status"
                    :key="index"
                    :value="data.uuid"
                  >
                    {{ data.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="rounded-l bg-brand py-2 px-4 text-center">
              <h3 class="text-white mb-0">{{ count }}</h3>
              <p class="mb-0 text-white">Total Grooms</p>
            </div>
          </div>
        </div>
        <div class="table-wrap table-responsive " id="table-conetnt">
          <table
            class="table table-style-1 table-striped table-hover text-center"
            id="sorting_tbl"
          >
            <thead>
              <tr>
                <th
                  class="sorting cursor-pointer"
                  id="id-reg"
                  v-on:click="sorting('registration_no', 'id-reg')"
                >
                  Reg No.
                </th>
                <th>Photo</th>
                <th
                  class="sorting cursor-pointer"
                  id="id-surname"
                  v-on:click="sorting('last_name', 'id-surname')"
                >
                  Surname
                </th>
                <th
                  style="width: 100px"
                  class="sorting cursor-pointer"
                  id="id-dob"
                  v-on:click="sorting('dob', 'id-dob')"
                >
                  DOB
                </th>
                <th
                  class="sorting cursor-pointer"
                  id="id-status"
                  v-on:click="sorting('marital_status', 'id-status')"
                >
                  Marital Status
                </th>
                <th
                  class="sorting cursor-pointer"
                  id="id-height"
                  v-on:click="sorting('height', 'id-height')"
                >
                  Height
                </th>
                <th
                  class="sorting cursor-pointer"
                  id="id-edu"
                  v-on:click="sorting('education_courses', 'id-edu')"
                >
                  Education
                </th>
                <th
                  class="sorting cursor-pointer"
                  id="id-salary"
                  v-on:click="sorting('annual_income', 'id-salary')"
                >
                  Annual Income Lakh
                </th>
                <th
                  class="sorting cursor-pointer"
                  id="id-occupation"
                  v-on:click="sorting('occupation_details', 'id-occupation')"
                >
                  Occupation Details
                </th>
                <th
                  class="sorting cursor-pointer"
                  id="id-city"
                  v-on:click="sorting('working_place_taluka_name', 'id-city')"
                >
                  Work Location
                </th>
                <th
                  class="sorting cursor-pointer"
                  id="id-place"
                  v-on:click="sorting('native_place_taluka_name', 'id-place')"
                >
                  Native Place
                </th>
              </tr>
            </thead>
            <tbody v-if="!loader">
              <tr v-for="(data, index) in list" :key="index">
                <td>
                  {{ data.registration_no ? data.registration_no : "-" }}
                </td>
                <td>
                  <img
                    :src="data.image ? data.image : 'img/profile.svg'"
                    width="55"
                    class=""
                    alt=""
                    style="border-radius: 5px; object-fit: contain"
                  />
                </td>
                <td style="word-break: break-word !important">
                  <a
                    class="cursor-pointer"
                    v-on:click="goToUrl($event, data.uuid)"
                    >{{ data.last_name ? data.last_name : "-" }}</a
                  >
                </td>
                <td>
                  {{
                    data.dob ? $helperService.getFormatedDate(data.dob) : "-"
                  }}
                </td>
                <td>{{ data.maritial_status ? data.maritial_status : "-" }}</td>
                <td>
                  {{
                    data.height ? $helperService.getHeight(data.height) : "-"
                  }}
                </td>
                <td>
                  {{ data.education_courses ? data.education_courses : "-" }}
                </td>
                <td>
                  {{
                    data.annual_income || data.annual_income == 0
                      ? $helperService.kFormatter(data.annual_income)
                      : "-"
                  }}
                </td>
                <td>
                  {{ data.occupation_details ? data.occupation_details : "-" }}
                </td>
                <td>
                  {{
                    data.working_place_taluka_name
                      ? data.working_place_taluka_name
                      : ""
                  }}
                  {{
                    data.working_place_taluka_name &&
                    data.working_place_goan &&
                    mydetail.is_membership_subscribed == "Y"
                      ? ", "
                      : ""
                  }}
                  {{
                    !data.working_place_taluka_name && !data.working_place_goan
                      ? "-"
                      : ""
                  }}
                  <span v-show="mydetail.is_membership_subscribed == 'Y'">
                    {{ data.working_place_goan ? data.working_place_goan : "" }}
                  </span>
                </td>
                <td>
                  {{
                    data.native_place_district_name
                      ? data.native_place_district_name
                      : ""
                  }}
                  {{
                    data.native_place_district_name &&
                    data.native_place_taluka_name
                      ? ", "
                      : ""
                  }}
                  {{
                    !data.native_place_district_name &&
                    !data.native_place_taluka_name
                      ? "-"
                      : ""
                  }}
                  {{
                    data.native_place_taluka_name
                      ? data.native_place_taluka_name
                      : ""
                  }}
                </td>
              </tr>
            </tbody>
          </table>
          <ErrorComponent @retry="getList(0)" ref="errorComponent" />
        </div>
        <div class="row mx-0 mb-4">
          <div class="col-lg-12 mt-5 text-right" style="text-align-last: end">
            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination.vue";
export default {
  name: "AllBride",
  components: {
    ErrorComponent,
    Pagination,
  },
  data() {
    return {
      list: [],
      count: "",
      loader: true,
      offset: 0,
      mydetail: {},
      status_id: "",
      marital_status: [],
    };
  },
  mounted() {
    this.getList(0);
    this.getMeCall();
    this.getMaritalStatus();
    window.scrollTo(0, 9307);
    document.getElementById('navbarSupportedContent').classList.remove('show');
  },
  methods: {
    goToUrl(e, uuid) {
      var obj = {};
      obj.ht = e.layerY;
      obj.offset = this.offset - 1;
      this.$shareService.setMapValue("all_bride", obj);
      this.$router.push("/profile-view/" + uuid);
    },
    getMeCall() {
      this.$api
        .getAPI({
          _action: "/user/me",
        })
        .then((res) => {
          this.mydetail = res;
          this.$store.commit("setUser", res);
        })
        .catch(() => {});
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList(offset, order_by, sort_by) {
      this.loader = true;
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.updateListLoader(true);
      }

      var obj = {};
      if (this.status_id) {
        obj.marital_status_id = this.status_id;
      }
      if (order_by) {
        obj.order_by = order_by;
      }
      if (sort_by) {
        obj.sort_by = sort_by;
      }
      obj.gender = "F";

      if (offset == 0) {
        this.list = [];
      }

      var shareobj = this.$shareService.getMapValue("all_bride")
        ? this.$shareService.getMapValue("all_bride")
        : null;
      obj.offset = shareobj && shareobj.offset ? shareobj.offset : offset;
      this.$api
        .getAPI({
          _action: "/bride/list",
          _body: obj,
        })
        .then((res) => {
          this.loader = false;
          this.count = res.count;
          this.list = res.list;
          this.offset = res.next_offset;

          if (offset == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count, 100);
                this.$refs.listPagination.setCurrentPage(obj.offset + 1);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
           if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "Groom Not Available");
            this.$refs.errorComponent.updateListLoader(false);
          }
          if (shareobj && shareobj.ht) {
            setTimeout(() => {
              window.scrollTo(0, Number(shareobj.ht) - 180);
            }, 100);
          }
          this.$shareService.setMapValue("all_groom", null);
        })
        .catch(() => {
          this.loader = false;
          this.$refs.errorComponent.updateListLoader(false);
        });
    },
    getMaritalStatus() {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + "MARITAL_STATUS",
        })
        .then((res) => {
          this.marital_status = res.list;
        })
        .catch(() => {});
    },
    selectStatus() {
      this.getList(0);
    },
  },
};
</script>
<style>
.table-wrap table tr td {
  padding: 5px;
}
.table-style-1 thead th {
  padding: 10px;
}
</style>
